import * as React from "react"
import type { SVGProps } from "react"
const SvgDownloadFile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11 15.17V12q0-.43.29-.72A1 1 0 0 1 12 11q.42 0 .71.28.3.3.29.72v3.17l.9-.9a1 1 0 0 1 .34-.22 1 1 0 0 1 .37-.07 1 1 0 0 1 .7.32q.26.3.28.7a1 1 0 0 1-.29.7l-2.6 2.6q-.14.15-.32.2a1 1 0 0 1-.38.07 1 1 0 0 1-.37-.06 1 1 0 0 1-.33-.21l-2.6-2.6a1 1 0 0 1-.29-.7q.02-.4.32-.7.3-.28.7-.3.4 0 .7.3z" />
    <path
      fillRule="evenodd"
      d="M4.59 21.98q.59.6 1.41.6h12q.83 0 1.41-.6.6-.59.59-1.4V9.4a2 2 0 0 0-.57-1.4l-4.85-4.85a2 2 0 0 0-1.4-.58H6q-.82 0-1.41.59A2 2 0 0 0 4 4.57v16q0 .82.59 1.41M13 4.57v4q0 .42.29.71.29.3.71.29h4v11H6v-16z"
    />
  </svg>
)
export default SvgDownloadFile
